// @flow
import React from "react"
import { compose, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import Mobile from "components/Media/Mobile"
import Desktop from "components/Media/Desktop"
import { filter, clear } from "data/search/actions"
import { selectSearchParams } from "data/search/selectors"
import { chooseProductGroups, chooseGeolocation } from "data/app/actions"
import { selectProductGroups, selectGeolocation } from "data/app/selectors"
import { openModal } from "data/modals/actions"
import MobileFilters from "../MobileFilters"
import DesktopFilters from "../DesktopFilters"
import { MainFilterWrap } from "../styled"

const MainFilter = ({
  geolocation,
  productGroups,
  chooseProductGroups,
  params,
  clear,
  filter,
}) => {
  return (
    <MainFilterWrap>
      <Mobile>
        <MobileFilters
          geolocation={geolocation}
          productGroups={productGroups}
          chooseProductGroups ={chooseProductGroups}
          // chooseGeolocation={chooseGeolocation} disabled
          params={params}
          filter={filter}
          noPassport={true}
        />
      </Mobile>
      <Desktop>
        <DesktopFilters
          geolocation={geolocation}
          productGroups={productGroups}
          chooseProductGroups ={chooseProductGroups}
          // chooseGeolocation={chooseGeolocation} disabled
          params={params}
          filter={filter}
          clear={clear}
          noPassport={true}
        />
      </Desktop>
    </MainFilterWrap>
  )
}

const mapStateToProps = state => ({
  params: selectSearchParams(state),
  geolocation: selectGeolocation(state),
  productGroups: selectProductGroups(state),
})

const mapDispatchToProps = {
  filter,
  clear,
  chooseGeolocation,
  chooseProductGroups,
  openModal,
}

const enhancer: HOC<*, {||}> = compose(
  withConnect(mapStateToProps, mapDispatchToProps),
)

export default enhancer(MainFilter)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainFilter/AffiliateFilter/index.js